'use client';
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { appEnv } from '@cta-portal/webapp-common/lib/env';
import styled from 'styled-components';
import Layout from '../../../layout';
export default function LoginRedirect() {
    useEffect(function () {
        var urlParams = new URLSearchParams(globalThis.location.search);
        var _redirectUri = urlParams.get('redirect_uri');
        globalThis.location.href = _redirectUri || appEnv.client.portalUrl;
    }, []);
    return (_jsx(Layout, { children: _jsx(Container, { children: _jsx("p", { className: "title", children: "You're being redirected" }) }) }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  justify-content: center;\n  width: 100%;\n\n  .title {\n    font-size: 48px;\n    font-weight: 700;\n    text-align: center;\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  justify-content: center;\n  width: 100%;\n\n  .title {\n    font-size: 48px;\n    font-weight: 700;\n    text-align: center;\n  }\n"])));
var templateObject_1;
